import React from 'react';
import ReactDOM from 'react-dom';
import configureStore from './store/configureStore';
import { firebase } from './firebase/firebase';
import { Provider } from 'react-redux';
//actions
import {
  login,
  logout,
  sendPasswordResetEmail,
  startLogin,
} from './actions/auth';
//components
import IsAuthenticated from './components/IsAuthenticated';
import Login from 'locki-dashboard-navigation/dist/login';
import SelectPlace from './components/SelectPlace';
//Material-ui
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import 'typeface-roboto';
//styles
import './styles/main.scss';
//Img
import iso from './img/iso_light.svg';

const theme = createTheme({
  palette: {
    primary: {
      light: '#9b9b9b',
      main: '#2f2f2f',
      dark: '#050505',
      contrastText: '#d5d5d5',
    },
    secondary: {
      light: '#ffff66',
      main: '#ffbf00',
      dark: '#c79c00',
      contrastText: '#2f2f2f',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

const store = configureStore();
store.subscribe(() => {
  let state = store.getState();
});

firebase.auth().onAuthStateChanged((user) => {
  user ? store.dispatch(login(user.uid)) : store.dispatch(logout());
});

const loginComponent = (
  <Login
    handleForgot={(email) => store.dispatch(sendPasswordResetEmail(email))}
    handleLogin={(email, password) =>
      store.dispatch(startLogin(email, password))
    }
    logo={iso}
  />
);
const jsx = (
  <div>
    <CssBaseline />
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <IsAuthenticated itIs={<SelectPlace />} isNot={loginComponent} />
      </MuiThemeProvider>
    </Provider>
  </div>
);

ReactDOM.render(jsx, document.getElementById('app'));
